import { z } from 'zod';

import { mongoIdSchema } from './shared';

export enum OrganizationInviteStatus {
  Pending = 'pending',
  Rejected = 'rejected',
  Accepted = 'accepted',
}

export enum OrganizationUserRole {
  Owner = 'owner',
  Member = 'member',
  SuperAdmin = 'superAdmin',
}

export const allUserRoles = z.nativeEnum(OrganizationUserRole);
export const organizationUserSchema = z.object({
  _id: mongoIdSchema,
  organizationId: mongoIdSchema,
  userId: mongoIdSchema.nullish(),
  userEmail: z.string().email(), // required for invitations
  inviteStatus: z.nativeEnum(OrganizationInviteStatus),
  role: allUserRoles,
  roleLabel: z.string(),
  joinedAt: z.number().nullish(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type OrganizationUser = z.infer<typeof organizationUserSchema>;
